import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isSidebarCollapsed: localStorage.getItem('sidebarCollapsed') === 'true',
};

const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        toggleSidebar: (state) => {
            state.isSidebarCollapsed = !state.isSidebarCollapsed;
            localStorage.setItem('sidebarCollapsed', state.isSidebarCollapsed);
        },
        setSidebarCollapsed: (state, action) => {
            state.isSidebarCollapsed = action.payload;
            localStorage.setItem('sidebarCollapsed', action.payload);
        },
    },
});

export const { toggleSidebar, setSidebarCollapsed } = uiSlice.actions;
export default uiSlice.reducer;
